import { render } from "./BottomNavigation.vue?vue&type=template&id=7ce27076&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=7ce27076&scoped=true&lang=css"

import exportComponent from "E:\\myJS\\苏扬官网\\yihuBaiYing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce27076"]])

export default __exports__